export enum EmployeePayTypes {
  HOURLY = 'HOURLY',
  SALARY = 'SALARY',
  UNIT = 'UNIT',
}
